import { useState } from 'react';

import { SELECTION_OPTIONS } from '../constants';
import type { ProcessedCourseWiseBatchesData } from '../types';

interface UseBatchSelectionProps {
  processedBatchesData: ProcessedCourseWiseBatchesData;
  onAllSelected: () => void;
}

interface UseBatchSelectionReturn {
  selectedBatches: Record<string, string>;
  handleBatchSelection: (courseName: string, batchId: string) => void;
  handleWaitlistSelection: (courseName: string) => void;
}

export const useBatchSelection = ({
  processedBatchesData,
  onAllSelected,
}: UseBatchSelectionProps): UseBatchSelectionReturn => {
  const [selectedBatches, setSelectedBatches] = useState<
    Record<string, string>
  >({});

  const handleBatchSelection = (courseName: string, batchId: string) => {
    const newSelectedBatches = {
      ...selectedBatches,
      [courseName]: selectedBatches[courseName] === batchId ? '' : batchId,
    };
    setSelectedBatches(newSelectedBatches);

    // Check if all courses now have selected batches
    // const allCourseNames = Object.keys(processedBatchesFinalData);
    const allCourseNames = Object.keys(processedBatchesData).filter(
      name =>
        processedBatchesData[name].status !== 'batch_already_assigned' ||
        (processedBatchesData[name].other_batches.length > 0 &&
          processedBatchesData[name].recommended_batches.length > 0)
    );
    const allSelected = allCourseNames.every(name => newSelectedBatches[name]);
    if (allSelected && allCourseNames.length > 0) {
      onAllSelected();
    }
  };

  const handleWaitlistSelection = (courseName: string) => {
    const newSelectedBatches = {
      ...selectedBatches,
      [courseName]: SELECTION_OPTIONS.WAITLIST,
    };
    setSelectedBatches(newSelectedBatches);
    // Check if all courses now have selected batches or waitlist
    // const allCourseNames = Object.keys(processedBatchesData);
    const allCourseNames = Object.keys(processedBatchesData).filter(
      name => processedBatchesData[name].status !== 'batch_already_assigned'
    );
    const allSelected = allCourseNames.every(name => newSelectedBatches[name]);
    if (allSelected && allCourseNames.length > 0) {
      onAllSelected();
    }
  };

  return {
    selectedBatches,
    handleBatchSelection,
    handleWaitlistSelection,
  };
};
